import * as z from 'zod';

export const autoUpdateSettingsSchema = z.object({
  /**
   * Whether auto-updates are enabled or not.
   */
  enabled: z.boolean().prefault(true),
});

export type AutoUpdateSettings = z.infer<typeof autoUpdateSettingsSchema>;
